module.exports = __webpack_public_path__ + "static/img/2.29d4b5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/2.png
// module id = leCO
// module chunks = 1